// extracted by mini-css-extract-plugin
export default {"expanding-emoji":"Conversation_expanding-emoji__6Li1p","expand":"Conversation_expand__H3ZLW"};